import Logger from "../logger"

export default class ObjectUtil {
  static isNotNullOrUndefined<T>(value: T | null | undefined): value is T {
    return value !== null && value !== undefined
  }

  static isNullOrUndefined<T>(value: T | null | undefined): value is null | undefined {
    return value === null || value === undefined
  }

  static requiredNotNullOrUndefined<T>(
    value: T | null | undefined,
    message: () => string = () => "Required value is null or undefined"
  ): T {
    if (this.isNullOrUndefined(value)) {
      throw new Error(message())
    }
    return value
  }

  static fromMap<V>(map: Map<string, V>) {
    const object: Record<string, V> = {}
    map.forEach((value, key) => {
      object[key] = value
    })

    return object
  }

  static parseOrNull<T extends string>(types: readonly T[], type: string): T | undefined {
    const t = types.find((it) => it === type || it.toLowerCase() === type.toLowerCase())
    if (!t) {
      Logger.log.debug(`Unsupported type [${type}]. Please use the latest version of sdk.`)
    }
    return t
  }

  static parseAllOrNull<T extends string>(types: readonly T[], names: string[]): T[] | undefined {
    if (this.isNullOrUndefined(names)) {
      return undefined
    }
    const result = new Array<T>()
    for (let name of names) {
      const element = this.parseOrNull(types, name)
      if (this.isNullOrUndefined(element)) {
        return undefined
      }
      result.push(element)
    }
    return result
  }
}
